<template>
  <div style="padding-top: 5px; width: 830px; background-color: #f5f7f7;">
    <div class="app-main-inner adjust_rate">
      <div class="app-main-inner-row" style="padding: 0; margin-left: 10px;">
        <span style="font-size: 16px;">{{ IssueOfTheYear }}</span>
        <span style="font-size: 13px; margin-left: 15px;">{{ adjustRateAccountingDocumentNo }}</span>
      </div>
      <div class="app-main-inner-row" style="padding: 0; margin-left: 10px;">
        <el-form :inline="true" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_ProofDateP')" class="el-form-item-documentDate">
            <el-date-picker
              v-model="documentDate"
              type="date"
              :clearable="false"
              value-format="yyyy-MM-dd"
              :editable="false"
              no="1"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_VoucherLetter')" class="el-form-item-prefix" style="word-break: break-all; white-space: normal;">
            <el-select v-model="prefix" no="2">
              <el-option v-for="(item,index) in prefixList" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_VoucherNo')" class="el-form-item-documentNo">
            <el-input-number
              v-model="documentNo"
              :min="0"
              :precision="0"
              :controls="false"
              no="3"
              @blur="e => { if (e.target.value <= 0) documentNo = undefined }"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_VoucherAbstract')" class="el-form-item-summary">
            <el-input v-model="summary" no="4" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AccountTitle')" class="el-form-item-accountTitle">
            <el-select v-model="adjustAccountTitle" :filterable="true" no="5">
              <el-option
                v-for="(item,index) in accountTitleCollection"
                :key="index"
                :label="accountTitleLabelFun(item)"
                :value="item.accountTitle"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="app-main-inner-row" style="padding: 0; margin-left: 10px;">
        <span style="font-size: 14px;">{{ $t('CargoMsg.Cargo_ExchangeRateAdjustmentTable') }}</span>
      </div>
      <div class="app-main-inner-row row-grid" style="padding: 0; margin-left: 10px;height: 260px;width: 805px;">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          no="6"
        />
      </div>
      <div class="app-main-inner-row" style="margin-left: 10px; margin-bottom: 10px;flex-direction: row-reverse;">
        <el-button type="primary" :disabled="!hasNextRates || isProcessing" no="7" @click="adjustRateGeneratorBtnClickHandler">{{ $t('CargoMsg.Cargo_CreateVoucher') }}</el-button>
      </div>
    </div>
    <div style="height: 100%; background-color: #e2e8f3;" />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { generateAdjustRateAccountingDocument } from '@/api/financeManage/accountingDocument'
import StrUtils from '@/utils/StrUtils'
import * as accountingDocumentTypeApi from '@/api/financeManage/accountingDocumentType'

export default {
  name: 'AdjustRate',
  props: {
    accountSet: { type: Object } // 账套
  },
  data() {
    return {
      documentDate: null, // 凭证日期
      prefix: '收', // 凭证字
      documentNo: undefined, // 凭证号
      summary: this.$t('FinanceManage.ForeignCurrencyRevaluation'), // 摘要
      adjustAccountTitle: '', // 科目
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCopyRowsToClipboard: true,
        suppressRowSelection: true,
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        pagination: false,
        defaultColDef: {
          filter: false
        }
      },
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 170 },
        { headerName: this.$t('CargoMsg.Cargo_CurrentExchangeRate'), field: 'currentRate', width: 300 },
        { headerName: this.$t('CargoMsg.Cargo_AdjustFxRateEndOfPeriod'), field: 'nextRate', width: 300 }
      ],
      processing: false,
      prefixList: [ // 凭证字下拉框集合
        { value: '收', label: this.$t('FinanceManage.Receive') },
        { value: '付', label: this.$t('FinanceManage.Pay') },
        { value: '转', label: this.$t('FinanceManage.Transfer') },
        { value: '*', label: '*' }
      ]
    }
  },
  computed: {
    IssueOfTheYear() {
      return this.accountSet ? this.$t('CargoMsg.Cargo_IssueOfTheYear').format(this.accountSet.currentFiscalPeriod.year, this.accountSet.currentFiscalPeriod.month) : ''
    },
    accountTitleCollection() {
      return this.accountSet ? this.accountSet.accountTitle : []
    },
    adjustRateAccountingDocumentNo() {
      let documentNo = ''
      if (this.accountSet && this.accountSet.result) {
        const adjustRateAccountingDocument = this.accountSet.result.adjustRateAccountingDocument
        if (adjustRateAccountingDocument !== '') {
          documentNo = this.$t('CargoMsg.Cargo_PEERAVC') + adjustRateAccountingDocument.prefix + '-' + adjustRateAccountingDocument.documentNo
        }
      }
      return documentNo
    },
    hasNextRates() {
      return (this.accountSet && this.accountSet.result) ? this.accountSet.result.nextRates.length > 0 : false
    },
    rowData() {
      return (this.accountSet && this.accountSet.result) ? this.accountSet.result.exchangeRateAdjustmentList : []
    },
    isProcessing() {
      return this.processing
    }
  },
  watch: {
    async accountSet(newVal) {
      if (newVal && newVal.uuid) {
        await accountingDocumentTypeApi.query({ accountingSetKey: newVal.uuid }).then(res => {
          if (res.data.list && res.data.list.length > 0) {
            for (const row of res.data.list) {
              if (row.prefix && this.prefixList.findIndex(p => p.value === row.prefix) < 0) {
                this.prefixList.push({ value: row.prefix, label: row.prefix })
              }
            }
          }
        }).catch(() => {})
      }
    }
  },
  methods: {
    accountTitleLabelFun(accountTitle) {
      return accountTitle ? accountTitle.accountTitle + '_' + accountTitle.accountTitleName : ''
    },
    // 生成凭证
    adjustRateGeneratorBtnClickHandler() {
      if (!this.validatePreAdjustRate()) return
      const requestBody = {
        'accountSetKey': this.accountSet.uuid,
        'currentFiscalPeriodKey': this.accountSet.currentFiscalPeriod.uuid,
        'prefix': this.prefix,
        'documentNo': this.documentNo,
        'summary': this.summary,
        'documentDate': this.documentDate,
        'adjustAccountTitle': this.adjustAccountTitle,
        'branchId': this.$store.getters.currentOfficeId }
      if (this.isProcessing) return
      this.processing = true
      this.loading = getLoading()
      generateAdjustRateAccountingDocument(requestBody).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_PEFEAS'))
        this.accountSet.result.adjustRateAccountingDocument = res.data
      }).finally(() => {
        this.processing = false
        this.loading.close()
      })
    },
    validatePreAdjustRate() {
      if (!this.documentDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VoucherDateCanTBeEmpty'))
        return false
      }
      if (StrUtils.isEmpty(this.prefix)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VoucherLetterCanTBeEmpty'))
        return false
      }
      if (isNaN(this.documentNo)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VoucherNoCanTBeEmpty'))
        return false
      }
      if (StrUtils.isEmpty(this.adjustAccountTitle)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AccountTitleCanTBeEmpty'))
        return false
      }
      return true
    }
  }
}
</script>
